

/** 混入方法 :::
 *  @mixin mixFormConfig 表单项属性解构混入
 */
import { mixFormConfig } from "@/mixins/common/mix_form_config.js";
/** 工具方法 :::
 *  @function makeComputedGroup 生成计算属性组方法
 */
import { makeComputedGroup } from "@/utils/computed_utils.js";


/** @name PreviewItemTemplate.vue 混入
 *  @author 王汝鹏
 *  @version 2019-11-29
 */
export const mixPreviewItemTemplate = {
  mixins: [ mixFormConfig ],
  inject: [
    'preview_item_template_store',
    'preview_item_template_node_action_manager'
  ],
  computed: {
    /** 计算属性说明 ::: 
     *  @return {Object} formMap 表单项字典
     *  @return {Object} formModels 表单项填写内容
     *  @return {Boolean} itemPickControl 表单项提取开关
     *  @return {Object} pickListState 勾选的表单项列表
     */
    ...makeComputedGroup("preview_item_template_store", {
      formMap: { get: "formMap" },
      formModels: { get: "formModels" },
      itemPickControl: { get: "itemPickControl" },
      pickListState: "pickListState",
      toggleClearModelState: "toggleClearModelState"
      
    }),
    /** @name 节点行为管理者
     *  @return {Function} 节点行为管理者
     */
    nodeActionManager() { return this.preview_item_template_node_action_manager; },
    /** @name 当前表单项是否勾选
     *  @return {Boolean} 当前表单项是否勾选
     */
    itemPickModel: {
      get () { return Reflect.has(this.pickListState, this.selfId); },
      set (newValue) {
        /**
         * 根据勾选判断是否存储数据，如果勾选为真，添加组件相关配置，
         * 如果为false,证明之前勾过，删除当前已有数据
        */
        newValue ? Reflect.set(this.pickListState, this.selfId, this.formConfig) 
                 : Reflect.deleteProperty(this.pickListState, this.selfId);
        this.pickListState = {...this.pickListState};
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/preview_item/mix_preview_item_template.js